import { useState } from "react"


export const MaintenanceState = () => {
    const [region, setRegion] = useState([])
    const [province, setProvince] = useState([])
    const [municipality, setMunicipality] = useState([])
    const [barangay, setBarangay] = useState([])
    const [form, setForm] = useState({region: '', province: '', municipality: '', barangay: '', shipping_fee: '', active: true, type: ''})
    const [viewLoader, setViewLoader] = useState(true)
    const [error, setError] = useState(false)
    const [openSetUp, setOpenSetUp] = useState(false)
    const [shippingList, setShippingList] = useState([])
    const [confirmation, setConfirmation] = useState(false)
    const [btnLoader, setBtnLoader] = useState(false)
    const [listLoader, setListLoader] = useState(false)
    return {
        region: {data: region, set: setRegion},
        province: {data: province, set: setProvince},
        municipality: {data: municipality, set: setMunicipality},
        barangay: {data: barangay, set: setBarangay},
        form: {data: form, set: setForm},
        viewLoader: {data: viewLoader, set: setViewLoader},
        error: {data: error, set: setError},
        openSetUp: {data: openSetUp, set: setOpenSetUp},
        shippingList: {data: shippingList, set: setShippingList},
        confirmation: {data: confirmation, set: setConfirmation},
        btnLoader: {data: btnLoader, set: setBtnLoader},
        listLoader: {data: listLoader, set: setListLoader},
    }
}
